import { React, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { ComentariosOTModal } from "./ComentariosOTModal";
import FiltroMultiple from "../Dashboard/Modales/FiltroMultiple";

const CAMPOS_FILTRO = ["tipo"];
const estadoFiltroInicial = () => CAMPOS_FILTRO.reduce((acc, k) => ({ ...acc, [k]: [] }), {});

export const OrdenTrabajoAbiertaSucursalScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const { sucursal, nombreSucursal } = location.state || {};

    const [datos, setDatos] = useState(null);
    const [datosFiltrados, setDatosFiltrados] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false, alerta: false, error: false, mensaje: "",
    });
    const [modalComentarios, setModalComentarios] = useState({ open: false, row: null });

    const [options, setOptions] = useState(estadoFiltroInicial);
    const [filtros, setFiltros] = useState(estadoFiltroInicial);
    const [filtrosTemp, setFiltrosTemp] = useState(estadoFiltroInicial);
    const [mostrarFiltro, setMostrarFiltro] = useState(
        CAMPOS_FILTRO.reduce((acc, k) => ({ ...acc, [k]: { open: false } }), {})
    );
    const [prioridadFiltros, setPrioridadFiltros] = useState([]);

    useEffect(() => {
        if (!sucursal) {
            Swal.fire("Error", "No se especificó la sucursal.", "error");
            return;
        }
        GetDatos();
    }, []);

    const GetDatos = async () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        try {
            const result = await request.get(
                `OrdenTrabajoAbiertaSucursal/ObtenerOrdenesAbiertasSucursal?sucursal=${sucursal}`
            );
            setDatos(result);
            setLoader((prev) => ({ ...prev, mostrar: false }));
        } catch {
            setLoader((prev) => ({ ...prev, mostrar: false }));
            Swal.fire("Error", "Ocurrió un error al cargar la información.", "error");
        }
    };

    const FormatKm = (valor) =>
        Number(valor || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 });

    const onAbrirComentarios = (row) => {
        setModalComentarios({ open: true, row });
    };

    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros((prev) => (prev.includes(filtro) ? prev : [...prev, filtro]));
    };

    useEffect(() => {
        if (!Array.isArray(datos)) return;
        const tipoOptions = [...new Set(datos.map((r) => r.v_tipo).filter(Boolean))]
            .map((v) => ({ value: v, label: v }));
        setOptions({ tipo: tipoOptions });
    }, [datos]);

    useEffect(() => {
        if (!Array.isArray(datos)) {
            setDatosFiltrados([]);
            return;
        }
        let data = [...datos];
        if (filtros.tipo?.length > 0) {
            data = data.filter((r) => filtros.tipo.includes(r.v_tipo));
        }
        setDatosFiltrados(data);
    }, [datos, filtros]);

    const totales = datosFiltrados.reduce(
        (acc, r) => ({
            antiguedad: acc.antiguedad + Number(r.v_antiguedad || 0),
            manobra: acc.manobra + Number(r.v_manobra || 0),
            refacciones: acc.refacciones + Number(r.v_refacciones || 0),
            trabajoforaneo: acc.trabajoforaneo + Number(r.v_trabajoforaneo || 0),
            kilometraje: acc.kilometraje + Number(r.v_Kilometraje || 0),
        }),
        { antiguedad: 0, manobra: 0, refacciones: 0, trabajoforaneo: 0, kilometraje: 0 }
    );

    const promedioAntiguedad = datosFiltrados.length > 0
        ? Math.round(totales.antiguedad / datosFiltrados.length)
        : 0;

    return (
        <div className="otas-main-screen">
            <LoaderScreen loader={loader} />

            <div className="otas-body">
                <div className="otas-page">
                    <div className="otas-module">

                        <div className="otas-module-head">
                            <div className="otas-head-grid">

                                <div className="otas-head-left">
                                    <button
                                        className="otas-btn-secondary otas-btn-amarillo"
                                        onClick={() => history.goBack()}
                                    >
                                        <ArrowBackIcon fontSize="small" /> Regresar
                                    </button>
                                </div>
                                <div className="otas-head-center">
                                    <h1 className="otas-title">ORDEN DE TRABAJO ABIERTA SUCURSAL</h1>
                                    <p className="otas-head-period">
                                        {nombreSucursal ? nombreSucursal.toUpperCase() : ""}
                                    </p>
                                </div>

                                <div className="otas-head-right" />
                            </div>

                            <div className="otas-head-divider">
                                <div className="otas-head-divider-dot" />
                            </div>
                        </div>

                        {datos && datos.length > 0 && (
                            <>
                                <div className="otas-tabla-section">
                                    <div className="otas-tabla-head">
                                        <div></div>
                                        <div>Cliente</div>
                                        <div>Antigüedad</div>
                                        <div>Mano de obra</div>
                                        <div>Refacciones</div>
                                        <div>Trabajo foráneo</div>
                                        <div>Kilometraje</div>
                                        <div>Descripción de falla</div>
                                        <div className="borde-izq">
                                            <FiltroMultiple
                                                label="Tipo"
                                                field="tipo"
                                                options={options.tipo}
                                                filtros={filtros}
                                                setFiltros={setFiltros}
                                                filtrosTemp={filtrosTemp}
                                                setFiltrosTemp={setFiltrosTemp}
                                                mostrarFiltro={mostrarFiltro}
                                                setMostrarFiltro={setMostrarFiltro}
                                                actualizarPrioridad={actualizarPrioridad}
                                                setPrioridadFiltros={setPrioridadFiltros}
                                            />
                                        </div>
                                    </div>

                                    {datosFiltrados.length > 0 ? (
                                        datosFiltrados.map((r, index) => (
                                            <div key={index} className="otas-tabla-row">
                                                <div className="otas-cell-comentarios">
                                                    <VisibilityIcon
                                                        fontSize="small"
                                                        onClick={() => onAbrirComentarios(r)}
                                                    />
                                                </div>
                                                <div className="otas-cell-texto">{r.cliente}</div>
                                                <div className="otas-cell-num">{r.v_antiguedad}</div>
                                                <div className="otas-cell-importe">{FormatMoney(r.v_manobra, 0)}</div>
                                                <div className="otas-cell-importe">{FormatMoney(r.v_refacciones, 0)}</div>
                                                <div className="otas-cell-importe">{FormatMoney(r.v_trabajoforaneo, 0)}</div>
                                                <div className="otas-cell-importe">{FormatKm(r.v_Kilometraje)}</div>
                                                <div className="otas-cell-texto otas-cell-falla" title={r.v_descfalla}>
                                                    {r.v_descfalla}
                                                </div>
                                                <div className="otas-cell-tipo">{r.v_tipo}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="otas-tabla-sin-resultados">
                                            Ninguna orden coincide con el filtro seleccionado.
                                        </div>
                                    )}
                                </div>

                                <div className="otas-tabla-footer">
                                    <div></div>
                                    <div className="otas-footer-label">Total</div>
                                    <div className="otas-cell-num">Prom: ({promedioAntiguedad})</div>
                                    <div className="otas-cell-importe">{FormatMoney(totales.manobra, 0)}</div>
                                    <div className="otas-cell-importe">{FormatMoney(totales.refacciones, 0)}</div>
                                    <div className="otas-cell-importe">{FormatMoney(totales.trabajoforaneo, 0)}</div>
                                    <div className="otas-cell-importe">{FormatKm(totales.kilometraje)}</div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </>
                        )}

                        {!loader.mostrar && (!datos || datos.length === 0) && (
                            <div className="otas-empty-state">
                                <p>No hay órdenes de trabajo abiertas para esta sucursal.</p>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <ComentariosOTModal
                open={modalComentarios.open}
                onClose={() => setModalComentarios((prev) => ({ ...prev, open: false }))}
                ot={modalComentarios.row?.v_ot}
                row={modalComentarios.row}
            />
        </div>
    );
};

export default OrdenTrabajoAbiertaSucursalScreen;
